import { isEmpty } from 'lodash';

import { ChronicDiseaseSimple } from '@dreryk/egabinet-patient-medical-information-frontend-api';
import { Diagnosis, VisitPreviouslyUsedDiagnosisQuery } from '@dreryk/egabinet-visit-frontend-api';

import { performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, Link } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../translations';
import { dispatchVisitDiagnosesAppendEvent } from '../../../VisitFormSynchronization.event';
import { useVisitFormSyncing } from '../../../VisitFormSynchronization.hooks';

type UseDiagnosesFromLastVisitCopyLinkOptions = {
   visitId: number;
   chronicDiseases: ChronicDiseaseSimple[];
};

export const useDiagnosesFromLastVisitCopyLink = (options: UseDiagnosesFromLastVisitCopyLinkOptions): JSX.Element => {
   const visitFormSyncing = useVisitFormSyncing();

   const copyDiagnosesFormLastVisit = async (): Promise<void | boolean> => {
      const diagnoses = await performCqrsQuerySearch<Diagnosis>(() => {
         const query = new VisitPreviouslyUsedDiagnosisQuery();
         query.visitId = options.visitId;
         return query;
      });
      if (isEmpty(diagnoses)) {
         return dispatchSnackbarNegativeEvent(visitDetailsTranslationKeys.diagnoses.noDiagnosesAtPreviousVisit);
      }

      return dispatchVisitDiagnosesAppendEvent(
         diagnoses.map((diagnosis) => ({
            code: diagnosis.code,
            name: diagnosis.name,
            main: diagnosis.main,
            additionalInformation: diagnosis.additionalInformation ?? null,
         }))
      );
   };

   return (
      <Link
         testId={'copyDiagnosesFromLastVisit'}
         label={visitDetailsTranslationKeys.diagnoses.copyDiagnosesFromLastVisit}
         onClick={copyDiagnosesFormLastVisit}
         block={false}
         disabled={visitFormSyncing}
      />
   );
};
